module.exports = "gl_PointSize = point_size;";